import React, { useState, useMemo, Fragment, useEffect } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import GridContainer from 'components/Grid/GridContainer';
import TextField from '@material-ui/core/TextField';
import GridItem from 'components/Grid/GridItem';
import { Autocomplete } from '@material-ui/lab';
import Radio from '@material-ui/core/Radio';
import useDebounce from 'hooks/useDebounce';
import Button from 'components/CustomButtons/Button';
import PaymentIcon from '@material-ui/icons/Payment';

import { CircularProgress, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

// Ws
import { wsGet, wsFindBy } from 'services/WService';

function PaymentBusinessPartnerHeader(props) {
  const { paymentType } = props;
  const { bpId, DocType, zones } = props;
  const { payment, setPayment } = props;
  const { isEmployee, setIsEmployee } = props;
  const { businessPartner, setBusinessPartner } = props;
  const { payWithDocuments, setPayWithDocuments } = props;
  const { processing, onImport, paymentMethod } = props;
  const [bpText, setBpText] = useState('');
  const debouncedBpText = useDebounce(bpText, 500);
  const [loading, setLoading] = useState(false);

  const [businessPartners, setBusinessPartners] = useState([]);

  const bp = useMemo(() => {
    let bp = businessPartners.find((bp) => payment.base_business_partner_id == bp.id);
    if (bp === undefined) return {};
    return bp;
  }, [businessPartners, payment]);

  async function listBusinessPartners(CardCode) {
    if (CardCode.length < 3) return;
    setLoading(true);
    let res = await wsFindBy('base/business-partner', {
      limit: 20,
      CardType: DocType,
      CardCode,
    });

    if (res.success) {
      setBusinessPartners(res.data);
    }
    setLoading(false);
  }

  useEffect(() => {
    listBusinessPartners(debouncedBpText);
    // Do fetch here...
    // Triggers when "debouncedValue" changes
  }, [debouncedBpText]);

  useEffect(() => {
    // Si hay un socio fijo, obtener datos de el
    if (bpId != 0) {
      wsGet('base/business-partner', bpId).then((res) => {
        setBusinessPartners([res.data]);
        setBusinessPartner(res.data);
      });
    }
    return () => {
      setBusinessPartners([]);
      setBusinessPartner(undefined);
      setIsEmployee(false);
    };
  }, [bpId, DocType]);

  useEffect(() => {
    if (bp === undefined || bp === null) {
      setIsEmployee(false);
    }

    if (bp.QryGroup5 === 'Y') {
      setIsEmployee(true);
    } else {
      setIsEmployee(false);
    }
  }, [bp]);

  return (
    <Fragment>
      <GridContainer>
        {/* Buscador */}
        <GridItem xs={12} sm={4} lg={3}>
          <Autocomplete
            loading={loading}
            fullWidth
            disabled={bpId != 0}
            value={bp}
            options={businessPartners}
            getOptionLabel={(option) => {
              if (option.CardCode === undefined) return bpText;
              return `(${option.CardCode}) - ${option.CardName}`;
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Buscar"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading && <CircularProgress color="inherit" size={20} />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
            onInputChange={(e, value, eventType) => {
              if (eventType === 'input') {
                setBpText(value);
                return;
              }

              if (eventType === 'clear') {
                setPayment((payment) => ({ ...payment, base_business_partner_id: undefined }));
                setBusinessPartner(undefined);
                setBusinessPartners([]);
                setPayWithDocuments(true);
                setBpText('');
              }
            }}
            onChange={(e, value, eventType) => {
              if (eventType === 'select-option') {
                let bp = businessPartners.find((bp) => bp.id === value.id);
                setPayment((payment) => ({ ...payment, base_business_partner_id: value.id }));
                setBusinessPartner(bp);
                setBpText('');
                return;
              }
            }}
          />
        </GridItem>
        {/* CardName */}
        <GridItem xs={12} sm={4} lg={3}>
          <TextField
            disabled
            value={bp.CardName || ''}
            fullWidth
            label={DocType == 'C' ? 'Cliente' : 'Proveedor'}
          />
        </GridItem>
        {/* Zona */}
        <GridItem xs={12} md={4} lg={3}>
          <FormControl fullWidth required={payWithDocuments === false}>
            <InputLabel>Zona</InputLabel>
            <Select
              onChange={(e) => {
                let base_zone_id = e.target.value;
                if (base_zone_id === 'T') {
                  base_zone_id = undefined;
                }
                setPayment((payment) => ({ ...payment, base_zone_id }));
              }}
              value={payment.base_zone_id || 'T'}
              required={payWithDocuments === false}
            >
              {payWithDocuments && <MenuItem value={'T'}>Automático</MenuItem>}
              {zones.map((zone) => {
                return (
                  <MenuItem value={zone.id} key={zone.id}>
                    {zone.description}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </GridItem>
      </GridContainer>

      {isEmployee && (
        // Mostrar checkboxes tipo pago (Documentos o adelante sueldo)
        <GridContainer style={{ marginTop: '20px' }}>
          <GridItem xs={12} sm={3} md={2} xl={1}>
            <h4>Pagar por:</h4>
          </GridItem>

          <GridItem xs={12} sm={9} md={10} xl={11}>
            <FormControlLabel
              label="Documentos"
              disabled={bpId != 0}
              control={
                <Radio checked={payWithDocuments} onClick={() => setPayWithDocuments(true)} />
              }
            />
            <FormControlLabel
              label="Entrega a rendir cuenta"
              disabled={bpId != 0}
              control={
                <Radio checked={!payWithDocuments} onClick={() => setPayWithDocuments(false)} />
              }
            />
          </GridItem>
        </GridContainer>
      )}
        <GridContainer justify="flex-end">
          <GridItem xs={6} lg={2}>
            <Button
              fullWidth
              type="submit"
              form="formProcess"
              color="success"
              disabled={processing || paymentMethod === null}
            >
              <PaymentIcon /> Procesar
            </Button>
          </GridItem>
          <GridItem xs={6} lg={2}>
            <Button
              fullWidth
              color="info"
              onClick={onImport}
            >
              <PaymentIcon /> Importar excel
            </Button>
          </GridItem>
        </GridContainer>
    </Fragment>
  );
}

export default PaymentBusinessPartnerHeader;
